function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import NewBuilder from './NewBuilder';
import { saveContractTemplateDraftToSession, loadContractTemplateDraftFromSession, clearContractTemplateDraftFromSession } from '../lib/contractBuilderDraft';
import { CONTRACT_MENTION_ITEMS, resolveMentionValue as resolveContractMentionValue } from '../lib/contractMentions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SESSION_DRAFT_DELAY_MS = 800;
var SERVER_AUTO_SAVE_DELAY_MS = 3000;
function EditContractNewBuilderTemplate() {
  var axios = require('axios')["default"];
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    templateId = _useState2[0],
    setTemplateId = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    exitUrl = _useState4[0],
    setExitUrl = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    newBuilderTree = _useState6[0],
    setNewBuilderTree = _useState6[1];
  var _useState7 = useState('#FFFFFF'),
    _useState8 = _slicedToArray(_useState7, 2),
    builderBackgroundColor = _useState8[0],
    setBuilderBackgroundColor = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    builderBackgroundImage = _useState10[0],
    setBuilderBackgroundImage = _useState10[1];
  var _useState11 = useState(30),
    _useState12 = _slicedToArray(_useState11, 2),
    builderDocumentPadding = _useState12[0],
    setBuilderDocumentPadding = _useState12[1];
  var _useState13 = useState('auto'),
    _useState14 = _slicedToArray(_useState13, 2),
    builderDocumentPageSize = _useState14[0],
    setBuilderDocumentPageSize = _useState14[1];
  var _useState15 = useState(true),
    _useState16 = _slicedToArray(_useState15, 2),
    isLoading = _useState16[0],
    setIsLoading = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    hasDraft = _useState18[0],
    setHasDraft = _useState18[1];
  var _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    saveStatus = _useState20[0],
    setSaveStatus = _useState20[1];
  var latestNewBuilderData = useRef(null);
  var sessionSaveTimerRef = useRef(null);
  var serverSaveTimerRef = useRef(null);
  var saveQueueRef = useRef(Promise.resolve());
  var statusClearTimerRef = useRef(null);
  var templateIdRef = useRef(0);
  var clearSaveStatusSoon = useCallback(function () {
    var delayMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1200;
    if (statusClearTimerRef.current) {
      clearTimeout(statusClearTimerRef.current);
    }
    statusClearTimerRef.current = setTimeout(function () {
      setSaveStatus('');
      statusClearTimerRef.current = null;
    }, delayMs);
  }, []);
  var persistDraftToSession = useCallback(function (design, html) {
    var idOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var id = idOverride || templateIdRef.current;
    if (!id) {
      return;
    }
    saveContractTemplateDraftToSession(id, design, html);
    setHasDraft(true);
  }, []);
  var saveDesign = useCallback(function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$silent = options.silent,
      silent = _options$silent === void 0 ? false : _options$silent,
      _options$exitAfter = options.exitAfter,
      exitAfter = _options$exitAfter === void 0 ? false : _options$exitAfter;
    var runSave = function runSave() {
      var _document$querySelect;
      var activeTemplateId = templateIdRef.current;
      if (!activeTemplateId) {
        return Promise.reject(new Error('Template not loaded'));
      }
      if (!latestNewBuilderData.current) {
        return Promise.reject(new Error('Nothing to save yet'));
      }
      var _latestNewBuilderData = latestNewBuilderData.current,
        design = _latestNewBuilderData.design,
        html = _latestNewBuilderData.html;
      var csrfToken = (_document$querySelect = document.querySelector('meta[name="csrf-token"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute('content');
      setSaveStatus('saving');
      return axios.post('/contract/save_template', {
        content: design,
        html: html,
        TemplateId: activeTemplateId
      }, {
        headers: csrfToken ? {
          'X-CSRF-TOKEN': csrfToken
        } : {}
      }).then(function (response) {
        var _response$data;
        var savedId = Number(((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.id) || activeTemplateId);
        if (savedId && savedId !== activeTemplateId) {
          var _window$history;
          clearContractTemplateDraftFromSession(activeTemplateId);
          templateIdRef.current = savedId;
          setTemplateId(savedId);
          var templateIdInput = document.getElementById('templateId');
          if (templateIdInput) {
            templateIdInput.value = String(savedId);
          }
          if ((_window$history = window.history) !== null && _window$history !== void 0 && _window$history.replaceState) {
            var nextUrl = window.location.pathname.replace(/\/\d+(\/?$)/, "/".concat(savedId, "$1"));
            window.history.replaceState({}, '', nextUrl + window.location.search);
          }
        }
        clearContractTemplateDraftFromSession(savedId);
        setHasDraft(false);
        setSaveStatus('');
        if (exitAfter && exitUrl) {
          window.location.href = exitUrl;
          return response;
        }
        if (!silent) {
          setSaveStatus('saved');
          clearSaveStatusSoon(1500);
        }
        return response;
      })["catch"](function (error) {
        console.error(error);
        setHasDraft(true);
        setSaveStatus('error');
        clearSaveStatusSoon(2500);
        throw error;
      });
    };
    var queued = saveQueueRef.current.then(runSave, runSave);
    saveQueueRef.current = queued["catch"](function () {});
    return queued;
  }, [exitUrl, clearSaveStatusSoon]);
  var queueAutoSaveRef = useRef(null);
  var queueAutoSave = useCallback(function () {
    if (!templateIdRef.current || !latestNewBuilderData.current) {
      return;
    }
    if (serverSaveTimerRef.current) {
      clearTimeout(serverSaveTimerRef.current);
    }
    serverSaveTimerRef.current = setTimeout(function () {
      saveDesign({
        silent: true
      })["catch"](function () {});
    }, SERVER_AUTO_SAVE_DELAY_MS);
  }, [saveDesign]);
  queueAutoSaveRef.current = queueAutoSave;
  var flushPendingSave = useCallback(function () {
    if (sessionSaveTimerRef.current) {
      clearTimeout(sessionSaveTimerRef.current);
      sessionSaveTimerRef.current = null;
      if (latestNewBuilderData.current) {
        persistDraftToSession(latestNewBuilderData.current.design, latestNewBuilderData.current.html);
      }
    }
    if (serverSaveTimerRef.current) {
      clearTimeout(serverSaveTimerRef.current);
      serverSaveTimerRef.current = null;
    }
    return saveDesign({
      silent: true
    });
  }, [persistDraftToSession, saveDesign]);
  var handleNewBuilderSave = useCallback(function (design, html) {
    latestNewBuilderData.current = {
      design: design,
      html: html
    };
    setHasDraft(true);
    if (sessionSaveTimerRef.current) {
      clearTimeout(sessionSaveTimerRef.current);
    }
    sessionSaveTimerRef.current = setTimeout(function () {
      persistDraftToSession(design, html);
    }, SESSION_DRAFT_DELAY_MS);
    queueAutoSave();
  }, [persistDraftToSession, queueAutoSave]);
  var mentionConfig = useMemo(function () {
    return {
      mode: 'template',
      documentId: null,
      items: CONTRACT_MENTION_ITEMS,
      resolveMentionValue: resolveContractMentionValue
    };
  }, []);
  var saveDesignAndExit = useCallback(function () {
    if (sessionSaveTimerRef.current) {
      clearTimeout(sessionSaveTimerRef.current);
      sessionSaveTimerRef.current = null;
    }
    if (serverSaveTimerRef.current) {
      clearTimeout(serverSaveTimerRef.current);
      serverSaveTimerRef.current = null;
    }
    return saveDesign({
      exitAfter: true
    });
  }, [saveDesign]);
  useEffect(function () {
    var _document$getElementB, _document$getElementB2;
    var id = (_document$getElementB = document.getElementById('templateId')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.value;
    if (id) {
      var numericId = Number(id);
      templateIdRef.current = numericId;
      setTemplateId(numericId);
    }
    var exit = (_document$getElementB2 = document.getElementById('templateExitUrl')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.value;
    if (exit) {
      setExitUrl(exit);
    }
  }, []);
  useEffect(function () {
    window.saveDesign = function () {
      return saveDesign();
    };
    window.saveDesignAndExit = saveDesignAndExit;
    window.flushBuilderSave = flushPendingSave;
    return function () {
      delete window.saveDesign;
      delete window.saveDesignAndExit;
      delete window.flushBuilderSave;
      if (sessionSaveTimerRef.current) {
        clearTimeout(sessionSaveTimerRef.current);
      }
      if (serverSaveTimerRef.current) {
        clearTimeout(serverSaveTimerRef.current);
      }
      if (statusClearTimerRef.current) {
        clearTimeout(statusClearTimerRef.current);
      }
    };
  }, [saveDesign, saveDesignAndExit, flushPendingSave]);
  useEffect(function () {
    if (templateId <= 0) {
      return;
    }
    setIsLoading(true);
    var sessionDraft = loadContractTemplateDraftFromSession(templateId);
    axios.get('/contract/view_template_design/' + templateId).then(function (response) {
      var _response$data2, _response$data$tree, _response$data3, _response$data4, _response$data$docume, _response$data5, _response$data6, _sessionDraft$design, _response$data7;
      var serverTree = (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.isNewBuilder ? (_response$data$tree = response.data.tree) !== null && _response$data$tree !== void 0 ? _response$data$tree : [] : [];
      var serverBackgroundColor = ((_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.background_color) || '#FFFFFF';
      var serverBackgroundImage = ((_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.background_image) || '';
      var serverDocumentPadding = (_response$data$docume = (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.document_padding) !== null && _response$data$docume !== void 0 ? _response$data$docume : 30;
      var serverDocumentPageSize = ((_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.document_page_size) || 'auto';
      var draftTree = sessionDraft === null || sessionDraft === void 0 || (_sessionDraft$design = sessionDraft.design) === null || _sessionDraft$design === void 0 ? void 0 : _sessionDraft$design.tree;
      var serverUpdatedAt = Number(((_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.updatedAt) || 0);
      var draftSavedAt = Number((sessionDraft === null || sessionDraft === void 0 ? void 0 : sessionDraft.savedAt) || 0);
      var useDraft = Array.isArray(draftTree) && draftTree.length > 0 && draftSavedAt > serverUpdatedAt;
      if (useDraft) {
        var _sessionDraft$design2, _sessionDraft$design$, _sessionDraft$design3, _sessionDraft$design$2, _sessionDraft$design4, _sessionDraft$design5, _sessionDraft$design6, _sessionDraft$design$3, _sessionDraft$design7, _sessionDraft$design$4, _sessionDraft$design8, _sessionDraft$design9, _queueAutoSaveRef$cur;
        setNewBuilderTree(draftTree);
        setBuilderBackgroundColor(((_sessionDraft$design2 = sessionDraft.design) === null || _sessionDraft$design2 === void 0 ? void 0 : _sessionDraft$design2.background_color) || serverBackgroundColor);
        setBuilderBackgroundImage((_sessionDraft$design$ = (_sessionDraft$design3 = sessionDraft.design) === null || _sessionDraft$design3 === void 0 ? void 0 : _sessionDraft$design3.background_image) !== null && _sessionDraft$design$ !== void 0 ? _sessionDraft$design$ : serverBackgroundImage);
        setBuilderDocumentPadding((_sessionDraft$design$2 = (_sessionDraft$design4 = sessionDraft.design) === null || _sessionDraft$design4 === void 0 ? void 0 : _sessionDraft$design4.document_padding) !== null && _sessionDraft$design$2 !== void 0 ? _sessionDraft$design$2 : serverDocumentPadding);
        setBuilderDocumentPageSize(((_sessionDraft$design5 = sessionDraft.design) === null || _sessionDraft$design5 === void 0 ? void 0 : _sessionDraft$design5.document_page_size) || serverDocumentPageSize);
        latestNewBuilderData.current = {
          design: _objectSpread(_objectSpread({}, sessionDraft.design || {}), {}, {
            tree: draftTree,
            background_color: ((_sessionDraft$design6 = sessionDraft.design) === null || _sessionDraft$design6 === void 0 ? void 0 : _sessionDraft$design6.background_color) || serverBackgroundColor,
            background_image: (_sessionDraft$design$3 = (_sessionDraft$design7 = sessionDraft.design) === null || _sessionDraft$design7 === void 0 ? void 0 : _sessionDraft$design7.background_image) !== null && _sessionDraft$design$3 !== void 0 ? _sessionDraft$design$3 : serverBackgroundImage,
            document_padding: (_sessionDraft$design$4 = (_sessionDraft$design8 = sessionDraft.design) === null || _sessionDraft$design8 === void 0 ? void 0 : _sessionDraft$design8.document_padding) !== null && _sessionDraft$design$4 !== void 0 ? _sessionDraft$design$4 : serverDocumentPadding,
            document_page_size: ((_sessionDraft$design9 = sessionDraft.design) === null || _sessionDraft$design9 === void 0 ? void 0 : _sessionDraft$design9.document_page_size) || serverDocumentPageSize
          }),
          html: sessionDraft.html || ''
        };
        setHasDraft(true);
        (_queueAutoSaveRef$cur = queueAutoSaveRef.current) === null || _queueAutoSaveRef$cur === void 0 ? void 0 : _queueAutoSaveRef$cur.call(queueAutoSaveRef);
      } else {
        if (sessionDraft) {
          clearContractTemplateDraftFromSession(templateId);
        }
        setNewBuilderTree(serverTree);
        setBuilderBackgroundColor(serverBackgroundColor);
        setBuilderBackgroundImage(serverBackgroundImage);
        setBuilderDocumentPadding(serverDocumentPadding);
        setBuilderDocumentPageSize(serverDocumentPageSize);
        setHasDraft(false);
      }
    })["catch"](function (error) {
      var _sessionDraft$design10;
      console.error(error);
      var draftTree = sessionDraft === null || sessionDraft === void 0 || (_sessionDraft$design10 = sessionDraft.design) === null || _sessionDraft$design10 === void 0 ? void 0 : _sessionDraft$design10.tree;
      if (Array.isArray(draftTree) && draftTree.length > 0) {
        var _sessionDraft$design11, _sessionDraft$design12, _sessionDraft$design$5, _sessionDraft$design13, _sessionDraft$design14;
        setNewBuilderTree(draftTree);
        setBuilderBackgroundColor(((_sessionDraft$design11 = sessionDraft.design) === null || _sessionDraft$design11 === void 0 ? void 0 : _sessionDraft$design11.background_color) || '#FFFFFF');
        setBuilderBackgroundImage(((_sessionDraft$design12 = sessionDraft.design) === null || _sessionDraft$design12 === void 0 ? void 0 : _sessionDraft$design12.background_image) || '');
        setBuilderDocumentPadding((_sessionDraft$design$5 = (_sessionDraft$design13 = sessionDraft.design) === null || _sessionDraft$design13 === void 0 ? void 0 : _sessionDraft$design13.document_padding) !== null && _sessionDraft$design$5 !== void 0 ? _sessionDraft$design$5 : 30);
        setBuilderDocumentPageSize(((_sessionDraft$design14 = sessionDraft.design) === null || _sessionDraft$design14 === void 0 ? void 0 : _sessionDraft$design14.document_page_size) || 'auto');
        latestNewBuilderData.current = {
          design: sessionDraft.design,
          html: sessionDraft.html || ''
        };
        setHasDraft(true);
      } else {
        setNewBuilderTree([]);
        setHasDraft(false);
      }
    })["finally"](function () {
      setIsLoading(false);
    });
  }, [templateId]);
  var statusMessage = saveStatus === 'saving' ? 'Saving draft...' : saveStatus === 'saved' ? 'Template saved' : saveStatus === 'error' ? 'Failed to save template' : hasDraft ? 'Draft saved' : '';
  var isError = saveStatus === 'error';
  if (isLoading) {
    return /*#__PURE__*/_jsx("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        color: '#64748b'
      },
      children: "Loading template..."
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100vh',
      position: 'relative'
    },
    children: [statusMessage && /*#__PURE__*/_jsx("div", {
      style: {
        padding: '6px 12px',
        color: isError ? '#b91c1c' : hasDraft && saveStatus !== 'saved' ? '#92400e' : '#15803d',
        background: isError ? '#fee2e2' : hasDraft && saveStatus !== 'saved' ? '#fef3c7' : '#dcfce7',
        border: "1px solid ".concat(isError ? '#fecaca' : hasDraft && saveStatus !== 'saved' ? '#fde68a' : '#bbf7d0'),
        fontWeight: '600',
        fontSize: '12px',
        lineHeight: '1.2',
        position: 'absolute',
        top: '70px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 'auto',
        maxWidth: '220px',
        zIndex: 1000,
        borderRadius: '6px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        whiteSpace: 'nowrap',
        pointerEvents: 'none'
      },
      children: statusMessage
    }), /*#__PURE__*/_jsx(NewBuilder, {
      initialTree: newBuilderTree,
      initialBackgroundColor: builderBackgroundColor,
      initialBackgroundImage: builderBackgroundImage,
      initialDocumentPadding: builderDocumentPadding,
      initialDocumentPageSize: builderDocumentPageSize,
      onSave: handleNewBuilderSave,
      height: "100vh",
      headerActions: {
        mode: 'template',
        exitUrl: exitUrl || undefined,
        previewUrl: templateId ? "/contract/view_template/".concat(templateId) : undefined
      },
      mentionConfig: mentionConfig
    }, "contract-template-builder-".concat(templateId))]
  });
}
export default EditContractNewBuilderTemplate;